import { Offer } from "../Entities/Offer";
import apiClient from "./api.client.service";

class OfferService {
  private offers: Offer[] = [];
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getAllOffers() {
    try {
      if (this.offers?.length > 0) {
        return this.offers;
      }
      const response = await apiClient.get(`${this.APIBaseUrl}/offer`);
      console.debug("🚀 ~ OfferService ~ getAllOffers ~ response:", response);
      this.offers = response.data;
      return this.offers;
    } catch (error) {
      console.error("🚀 ~ OfferService ~ getAllOffers ~ error:", error);
    }
  }

  async applyCoupon(couponCode: string) {
    try {
      const response = await apiClient.post(`${this.APIBaseUrl}/offer/apply`, {
        couponCode,
      });
      console.debug("🚀 ~ OfferService ~ applyCoupon ~ response:", response);
      return response.data;
    } catch (error) {
      console.error("🚀 ~ OfferService ~ applyCoupon ~ error:", error);
    }
  }

  async getOfferById(id: string) {
    if (this.offers?.length === 0) {
      await this.getAllOffers();
    }

    const offer = this.offers.find((offer) => offer._id === id);
    return offer;
  }
}
const offerService = new OfferService();
export default offerService;
